// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { discontinuedProductListLineStyles } from "@steiner/Overrides/Widgets/MyListsDetails/MyListDetailsDiscontinuedProductListLine";
import Trash from "@steiner/XDL/Icons/Trash";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, createLinkIconStyles, ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

discontinuedProductListLineStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: auto 1fr 224px;
        gap: 20px;
        align-items: start;
        padding: 12px;
        border-bottom: 1px solid ${color("common.border")};
        width: 100%;

        ${xScreen("lte", "sm")} {
            grid-template-columns: auto 1fr;
            grid-template-rows: auto auto;
            height: 100%;
            padding: 12px 0;
        }

        ${xScreen("lte", "xs")} {
            grid-template-columns: 1fr;
            grid-template-rows: auto auto auto;
            height: 100%;
        }
    `,
};

discontinuedProductListLineStyles.info = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        ${xScreen("lte", "xs")} {
            grid-column: 1 / 2;
            grid-row: 2 / 3;
        }
    `,
};

discontinuedProductListLineStyles.actions = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 8px;
        ${xScreen("lte", "sm")} {
            grid-column: 2 / 4;
            grid-row: 2 / 3;
        }
        ${xScreen("lte", "xs")} {
            grid-column: 1 / 2;
            grid-row: 3 / 4;
        }
    `,
};

discontinuedProductListLineStyles.deleteLink = {
    ...createLinkIconStyles({
        icon: Trash,
        linkStyles: {
            icon: {
                position: "left",
            },
        },
    }),
};

discontinuedProductListLineStyles.tableDeleteLink = {
    icon: {
        iconProps: {
            src: Trash,
            size: 15,
            css: css`
                margin-right: 0;
            `,
        },
    },
};

discontinuedProductListLineStyles.productPartNumbersStyles = {};

discontinuedProductListLineStyles.descriptionDataTableCell = {
    mergeCss: true,
    css: css`
        min-width: 200px;
        max-width: 400px;
        word-wrap: break-word;
        white-space: normal;
        ${TypographyStyle} {
            ${ellipsis(1)}
        }
    `,
};

discontinuedProductListLineStyles.chipTypographyStyles = {
    css: css`
        margin-bottom: 0;
    `,
};

discontinuedProductListLineStyles.restrictedDescriptionText = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    css: css`
        ${ellipsis(3)}
    `,
};

discontinuedProductListLineStyles.selectAndSort = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        ${xScreen("lte", "xs")} {
            flex-direction: row;
        }
    `,
};

discontinuedProductListLineStyles.selectedCheckbox = {
    iconProps: {
        css: css`
            margin-right: 0;
        `,
    },
};

discontinuedProductListLineStyles.sortOrderTextField = {
    mergeCss: true,
    cssOverrides: {
        inputSelect: css`
            width: 60px;
        `,
    },
};
